import React, { useState } from 'react';
import { api } from '../services/api';

const positions = ['Forward', 'Midfielder', 'Defender', 'Goalkeeper'];

const PlayerManagement = ({ token, onPlayerAdded }) => {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [position, setPosition] = useState('Forward');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.createPlayer(token, name.trim(), position);
      setName('');
      setPosition('Forward');
      setShowModal(false);
      if (onPlayerAdded) onPlayerAdded();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="flex items-center gap-2 bg-primary text-background font-manrope font-bold text-sm uppercase tracking-widest px-5 py-3 rounded-xl hover:bg-primary/90 transition-all"
      >
        <span className="material-symbols-outlined text-[18px]">person_add</span>
        Add Player
      </button>

      {showModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
          <div className="bg-surface-container border border-outline-variant/30 rounded-3xl p-6 sm:p-8 w-full max-w-md shadow-2xl">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-on-background font-lexend font-bold text-xl">Register New Player</h3>
              <button
                onClick={() => setShowModal(false)}
                className="text-stone-600 hover:text-on-background transition-colors"
              >
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-stone-600 font-manrope text-xs font-bold uppercase tracking-widest mb-2">
                  Player Name
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter name"
                  required
                  className="w-full bg-background border border-outline-variant/50 rounded-xl px-4 py-3 text-on-background font-manrope placeholder:text-stone-800 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-all"
                />
              </div>

              <div>
                <label className="block text-stone-600 font-manrope text-xs font-bold uppercase tracking-widest mb-2">
                  Position
                </label>
                <select
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                  className="w-full bg-background border border-outline-variant/50 rounded-xl px-4 py-3 text-on-background font-manrope focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-all"
                >
                  {positions.map(pos => (
                    <option key={pos} value={pos}>{pos}</option>
                  ))}
                </select>
              </div>

              {error && (
                <p className="text-rose-700 font-manrope text-sm">{error}</p>
              )}

              <div className="flex gap-3 pt-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 bg-primary text-background font-manrope font-bold text-sm uppercase tracking-widest py-3 rounded-xl hover:bg-primary/90 disabled:opacity-50 transition-all"
                >
                  {loading ? 'Adding...' : 'Add Player'}
                </button>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="flex-1 bg-background border border-outline-variant/50 text-stone-600 font-manrope font-bold text-sm uppercase tracking-widest py-3 rounded-xl hover:bg-surface-container transition-all"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default PlayerManagement;
